import {IhttpResponse} from "@/interfaces/http-interfaces";
import {AxiosResponse, AxiosError, AxiosRequestConfig} from "axios";
import axios from "axios";
import { BackendError } from "./errors/api_errors";
import globalStore from '@/core/store/globalStore';
/**
 * Extend default error handling: return any error as standard response.
 * All http errors by backend should handle on higher level
 */
axios.interceptors.response.use((response: AxiosResponse) => {
  return response;
}, (error: AxiosError) => {
    if(error.name === "CanceledError") throw new Error('CanceledError')
  return error.response;
});

axios.defaults.withCredentials = true;

type ResponseType = "arraybuffer" | "blob" | "document" | "json" | "text" | "stream"


/**
 * HTTP get request
 * @param url
 * @param queryParams
 * @param headers
 * @param no_auth
 * @param signal
 * @param responseType
 */
export const getRequest = async <Query extends Record<string, string>>(
  url: string,
  queryParams?: Query,
  headers: { [key: string]: string; } = {},
  no_auth = false,
  signal?: AbortSignal,
  responseType?: ResponseType
): Promise<IhttpResponse> => {
    const token = globalStore.getters.getToken;

    if (no_auth === false && (token !== undefined || token !== null) && !(url.includes("users/login"))){
        headers['Authorization'] = `Token ${token}`;
    }

    const config: AxiosRequestConfig = {
        url: url,
        method: 'get',
        headers,
        params: new URLSearchParams(queryParams),
        withCredentials: true,
        signal: signal,
        responseType,
    }

    try {
        const response: AxiosResponse<unknown, unknown> = await axios(config)
        const body = response.data as  {[p: string]: unknown};
        return {status: response.status, body, headers: response.headers} as IhttpResponse;
    } catch (err) {
        console.debug('err', err)
        const error = err as Error
        if(error.message === 'CanceledError' && 'message' in error){
            throw error
        } else {
            throw  new BackendError({message: 'Сервер не отвечает'})
        }
    }

}

export const getFileRequest = async (
    url: string,
): Promise<IhttpResponse> => {
    const token = globalStore.getters.getToken;
    const headers: { [key: string]: string } = {};

    if ((token !== undefined || token !== null) && !(url.includes("users/login"))){
        headers['Authorization'] = `Token ${token}`;
    }

    const config: AxiosRequestConfig = {
        url: url,
        method: 'get',
        headers,
        responseType: "blob",
        withCredentials: true,
    };
    const response = await axios(config);
    if (response === undefined){
        throw new BackendError({message: "Сервер не отвечает"})
    }
    return {status: response.status, body: response.data} as IhttpResponse;
}

/**
 * HTTP post request
 * @param url
 * @param body
 * @param headers
 */
export const postRequest = async (
    url: string,
    body: unknown,
    headers: { [key: string]: string; } = {},
    no_auth = false,
    signal?: AbortSignal,
): Promise<IhttpResponse> => {
    const token = globalStore.getters.getToken;
    if (no_auth === false && (token !== undefined || token !== null) && !(url.includes("users/login"))){
        headers['Authorization'] = `Token ${token}`;
    }

    const config: AxiosRequestConfig = {
        url: url,
        method: 'post',
        headers: headers,
        data: body,
        signal,
    };

    const response = await axios(config);
    if (response === undefined){
        throw new BackendError({message: "Сервер не отвечает"})
    }
    return {status: response.status, body: response.data} as IhttpResponse;
}

/**
 * HTTP patch request
 * @param url
 * @param body
 * @param headers
 */
export const patchRequest = async (
    url: string,
    body: unknown,
    headers: { [key: string]: string; } = {},
    no_auth = false,
): Promise<IhttpResponse> => {
    const token = globalStore.getters.getToken;
    if (no_auth === false && (token !== undefined || token !== null) && !(url.includes("users/login"))){
        headers['Authorization'] = `Token ${token}`;
    }
    const config: AxiosRequestConfig = {
        url: url,
        method: 'patch',
        headers: headers,
        data: body
    };
    const response = await axios(config);
    if (response === undefined){
        throw new BackendError({message: "Сервер не отвечает"})
    }
    return {status: response.status, body: response.data} as IhttpResponse;
}


/**
 * HTTP delete request
 * @param url
 * @param body
 * @param headers
 */
export const deleteRequest = async (
    url: string,
    body: number[] | { [key: string]: number[]|string[]|string|number|boolean; } = {},
    headers: { [key: string]: string; } = {}
): Promise<IhttpResponse> => {
    const token = globalStore.getters.getToken;
    if ((token !== undefined || token !== null) && !(url.includes("users/login"))){
        headers['Authorization'] = `Token ${token}`;
    }
    const config: AxiosRequestConfig = {
      url: url,
      method: 'delete',
      headers: headers,
      data: body
    };
    const response = await axios(config);
    if (response === undefined){
        throw new BackendError({message: "Сервер не отвечает"})
    }
    return {status: response.status, body: response.data} as IhttpResponse;
}

/**
 * HTTP patch request
 * @param url
 * @param body
 * @param headers
 */
export const putRequest = async (
  url: string,
  body: unknown,
  headers: { [key: string]: string; } = {},
  no_auth = false,
): Promise<IhttpResponse> => {
    const token = globalStore.getters.getToken;
    if (no_auth === false && (token !== undefined || token !== null) && !(url.includes("users/login"))){
        headers['Authorization'] = `Token ${token}`;
    }
    const config: AxiosRequestConfig = {
      url: url,
      method: 'put',
      headers: headers,
      data: body
    };
    const response = await axios(config);
    if (response === undefined){
      throw new BackendError({message: "Сервер не отвечает"})
    }
    return {status: response.status, body: response.data} as IhttpResponse;
}
